<input 
    #inputElement
    matInput 
    [placeholder]="placeholder" 
    [formControl]="formControl" 
    [matAutocomplete]="auto"
    (keydown)="onKeyDown($event)"
    (blur)="validateSelection()"
    [tabIndex]="tabIndex"
    class="autocomplete-option"
    [style.--option-color]="colorcode"
    />
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)" class="custom-autocomplete-pane">
    <cdk-virtual-scroll-viewport itemSize="50" class="options-viewport">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option" [disabled]="isOptionDisabled(nodeID, option)">
            <span class="custom-select-option" [style.--option-color]="option === 'Not Mapped' ? null :isOptionDisabled(nodeID, option) ? '#a4a3a3' : nodeColor">{{option}}</span>
        </mat-option>
    </cdk-virtual-scroll-viewport>
</mat-autocomplete>
<a #fakeclick></a> 

<!-- <input matInput type="text" [(ngModel)]="map.mapTo" [formControl]="mapControl" [matAutocomplete]="automap" class="custom-select-trigger" [style.--trigger-color]="map.mapTo==='Not Mapped' ? '#676767' : map.mapTo!==map.field ? '#a4a3a3' : mapper.nodeColor">
<mat-autocomplete autoActiveFirstOption #automap="matAutocomplete">
    <mat-option value="Not Mapped">Not Mapped</mat-option>
    <mat-option *ngFor="let col of mapOptions | async" [value]="col" [disabled]="isOptionDisabled(mapper.nodeID,col)">
        <span class="custom-select-option" [style.--option-color]="isOptionDisabled(mapper.nodeID, col) ? '#a4a3a3' : mapper.nodeColor">{{col}}</span>
    </mat-option>
</mat-autocomplete> -->